<template>
  <div class="main">
    <v-head :title="edit?'修改论文':'添加论文'"></v-head>
    <div style="width:86%; margin:5% auto; text-align:left">
      <el-form label-width="80px">
        <el-form-item label="论文标题">
          <el-input v-model="form.paper" placeholder="请输入论文标题" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属专题">
          <el-select v-model="form.paperTopic" placeholder="请选择所属专题">
            <el-option v-for="item in paperTopicList" :key="item.id" :label="item.topicName"
              :value="item.topicName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="论文作者">
          <el-input type="textarea" placeholder="请输入论文作者" resize="none" :row="5" v-model="form.author"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="作者单位">
          <el-input v-model="form.unit" placeholder="请输入第一作者单位" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="作者邮箱">
          <el-input v-model="form.email" placeholder="请输入第一作者邮箱" auto-complete="off"></el-input>
        </el-form-item>
        <span class="tips">附件请以摘要题目命名。</span>
        <el-form-item label="附件1" style=" text-align:left">
          <up-load v-if="edit&&form.id||!edit" v-model="form.fileId" :form="form" @setFileName="setFileName"
            :fileName="form.fileName" />
        </el-form-item>
        <el-form-item label="附件2" style=" text-align:left">
          <up-load v-if="edit&&form.id||!edit" v-model="form.fileId1" :form="form" @setFileName="setFileName1"
            :fileName="form.fileName1" />
        </el-form-item>
        <el-form-item label="附件3" style=" text-align:left">
          <up-load v-if="edit&&form.id||!edit" v-model="form.fileId2" :form="form" @setFileName="setFileName2"
            :fileName="form.fileName2" />
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>

    </div>
  </div>
</template>

<script>
  import { Toast } from "vant"
  import { paperTopics, paperSubmit } from "@/api/dictionary";
  import upLoad from "@/components/upload/upLoad";
  import { mapState, mapGetters } from "vuex"
  import vHead from "@/components/Subhead.vue";
  import { uploadFile } from "@/api/upload";
  export default {
    model: {
      prop: "form",
      event: "change"
    },
    components: {
      upLoad,
      vHead,
      [Toast.name]: Toast,
    },
    computed: {
      ...mapState([
        "paperType"
      ]),
      ...mapGetters([
        "commonList"
      ]),
      paperTypes() {
        let list = this.commonList('PAPER_TYPE');
        return list.sort((a, b) => a.code >= b.code ? 1 : -1);
      },
      edit() {
        return this.$route.query && this.$route.query.edit;
      }
    },
    data() {
      return {
        title: '添加论文',
        loading: false,
        fileList: [],
        show: true,
        paperTopicList: [],
        uploadUrl: uploadFile,
        form: {
          memberId: sessionStorage.getItem("memberId"),
          fileId: null,
          fileId1: null,
          fileId2: null,
          mobile: "",
          paperType: null,
          unit: "",
          placeId: null,
          author: "",
          fileName: "",
          email: "",
          paper: "",
          authorDescribe: "",
          accept: ''
        },
        meetingDetailsItem: {},
      };
    },
    methods: {
      setFileName(name) {
        this.form.fileName = name;
      },
      setFileName1(name) {
        this.form.fileName1 = name;
      },
      setFileName2(name) {
        this.form.fileName2 = name;
      },
      submit() {
        if (!this.form.fileId) {
          Toast.fail("请先上传附件");
        } else if (!this.form.paper) {
          Toast.fail("请输入论文标题");
        } else if (!this.form.author) {
          Toast.fail("请输入论文作者");
        } else if (!this.form.email) {
          Toast.fail("请输入作者邮箱");
        } else {
          this.form.meetingId = this.meetingDetailsItem.meetingId;
          this.form.registerId = this.meetingDetailsItem.id;
          this.form.seq = this.meetingDetailsItem.seq;
          paperSubmit(this.form).then(res => {
            if (res.success) {
              Toast.success("提交成功");
              this.paperShow = false;
              this.$router.push({ name: "meetingPapers" });
              this.$emit("update");
            }
          });
        }
      },
    },
    mounted() {
      this.meetingDetailsItem = JSON.parse(sessionStorage.getItem("meetingDetails"));
      if (this.edit) {
        this.form = { ...this.meetingDetailsItem }
      }
      paperTopics({ meetingId: this.meetingDetailsItem.meetingId })
        .then(res => {
          this.paperTopicList = res.result;
        })
    }
  };
</script>

<style scoped lang="less">
  /deep/.el-select {
    width: 100%
  }

  /deep/.el-textarea__inner {
    font-family: '微软雅黑';
  }

  /deep/.el-upload--text {
    text-align: left;

  }

  .tips {
    margin-left: 80px;
    display: block;
    color: red;
    text-align: left;
    font-size: 15px;
  }
</style>